import React from 'react'
import {Spin} from "antd"
import TenantTableHead from "./TenantTableHead"
import TenantTableBody from "./TenantTableBody"

const TenantTable = (props) => {
    const {loading, error, listTenantDealer} = props

    return (
        <div className="LeadTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu...">
                <table className="table">
                    <TenantTableHead/>
                    <TenantTableBody
                        loading={loading}
                        error={error}
                        listTenantDealer={listTenantDealer}
                    />
                </table>
            </Spin>
        </div>
    )
}

export default TenantTable
